import React from 'react';
import { Card, CardHeader, CardContent } from '@mui/material';

import Scrollbar from '../../../../../components/Scrollbar';
import { PromotionForm } from './PromotionForm';


export const FullScreenView = props => {
  const { data, submitCallback, handleClose, allSeasons, seasonChangeCallback, treeObjects, allPeriods, allPackages, allCalculationTypes } = props;

  return (
    <Scrollbar>
      <Card>
        <CardHeader title={data ? 'Edytuj promocję' : 'Dodaj promocję'} sx={{ mt: -1, mb: -2 }} />
        <CardContent>
          <PromotionForm
            seasonChangeCallback={seasonChangeCallback}
            data={data}
            submitCallback={submitCallback}
            handleClose={handleClose}
            allSeasons={allSeasons}
            treeObjects={treeObjects}
            allPeriods={allPeriods}
            allPackages={allPackages}
            allCalculationTypes={allCalculationTypes} />
        </CardContent>
      </Card>
    </Scrollbar>
  );
};
